import {createSlice, Dispatch} from '@reduxjs/toolkit';
import {AircraftDefinitionResponse, PagedAircraftsList, AircraftStatus} from 'app/types/service-types/AircraftTypes';
import {AircraftService} from 'app/services';

interface FetchAircraftsParams {
  page?: number;
  size?: number;
  status?: AircraftStatus;
}

export const fetchAllAircrafts = (params?: FetchAircraftsParams) => async (dispatch: Dispatch) => {
  dispatch(setLoading(true));
  try {
    const response = await AircraftService.getAll(params);
    // Handle both paginated and non-paginated responses
    if ('content' in response) {
      dispatch(setAircrafts(response.content));
      dispatch(setPagination({
        totalPages: response.totalPages || 0,
        totalElements: response.totalElements || 0,
        currentPage: response.number || 0,
        pageSize: response.size || 20
      }));
    } else {
      // Legacy non-paginated response
      dispatch(setAircrafts(response));
    }
  } catch (err) {
    console.log(err);
  }
  dispatch(setLoading(false));
}

export const fetchAircraftById = (id: string) => async (dispatch: Dispatch) => {
  dispatch(setDetailLoading(true));
  try {
    const response = await AircraftService.getById(id);
    dispatch(setSelectedAircraft(response));
  } catch (err) {
    console.log(err);
  }
  dispatch(setDetailLoading(false));
}

interface AircraftsSlice {
  aircrafts: AircraftDefinitionResponse[];
  loading: boolean;
  selectedAircraft: AircraftDefinitionResponse | null;
  detailLoading: boolean;
  pagination: {
    totalPages: number;
    totalElements: number;
    currentPage: number;
    pageSize: number;
  };
}

const initialState: AircraftsSlice = {
  aircrafts: [],
  loading: false,
  selectedAircraft: null,
  detailLoading: false,
  pagination: {
    totalPages: 0,
    totalElements: 0,
    currentPage: 0,
    pageSize: 20
  }
}

const stateSlice = createSlice({
  name: 'aircrafts/aircrafts-list',
  initialState,
  reducers: {
    setLoading: (state, action) => { state.loading = action.payload },
    setAircrafts: (state, action) => { state.aircrafts = action.payload },
    setSelectedAircraft: (state, action) => { state.selectedAircraft = action.payload },
    setDetailLoading: (state, action) => { state.detailLoading = action.payload },
    clearSelectedAircraft: (state) => { state.selectedAircraft = null },
    setPagination: (state, action) => { state.pagination = action.payload }
  }
});

export const {setLoading, setAircrafts, setSelectedAircraft, setDetailLoading, clearSelectedAircraft, setPagination} = stateSlice.actions;
export default stateSlice.reducer;
